/* eslint-disable eqeqeq */
/* eslint-disable react/no-find-dom-node */
import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import moment from 'moment';

import PopUp from '../../Popup';
import PowerEventUpgrade from './PowerEventUpgrade';
import PowerEventUpgradeContent from './PowerEventUpgradeContent';
import CheckoutForm from '../../CheckoutForm';
import { gtag } from '../../Analytics/gtag';

import { fetchUpgradePopup } from '../../../actions/upgrade-to-power-actions';
import { getPaymentMethods } from '../../../actions/member-payment-actions';

class UpgradeToPowerPopUp extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showCheckout: false,
            selectedInterval: 'year',
            popupHeight: 700,
            isAustrlainPowerUpgrade: false,
            playerPaymentMethods: [],
        };
        this.handleClick = this.handleClick.bind(this);
        this.handleSuccess = this.handleSuccess.bind(this);
        this.setCheckoutForm = this.setCheckoutForm.bind(this);
        this.setPopupHeight = this.setPopupHeight.bind(this);
        this.checkoutForm = null;
    }

    UNSAFE_componentWillMount() {
        const { user } = this.props.auth;
        const birthdate = user?.claimedPlayer?.playerProfileInformation?.playerProfile?.player?.birthDate || user?.birthdate;
        const currentAge = moment().diff(birthdate, 'years');
        if (user?.isAustralian && birthdate && currentAge < 13 && !this.props.isProTennisPowerUpgrade) {
            this.setState({ isAustrlainPowerUpgrade: true });
            this.props.fetchUpgradePopup('australianuser');
        }
    }

    setCheckoutForm(checkoutForm) {
        this.checkoutForm = checkoutForm;
    }

    handleClick(ev, interval) {
        this.setState({ showCheckout: true, selectedInterval: interval });
    }

    setPopupHeight() {
        if (!this.checkoutForm) {
            return;
        }
        const node = ReactDOM.findDOMNode(this.checkoutForm);
        const formHeight = node.offsetHeight + 45;
        if (formHeight != this.state.popupHeight) {
            this.setState({ popupHeight: formHeight });
        }
    }

    handleSuccess() {
        gtag('power-upgrade', {
            category: 'Power Upgrade',
            context: `Upgrade success`,
        });
        if (this.props.onSuccess) {
            this.props.onSuccess();
        } else {
            setTimeout(() => {
                this.props.onCloseClick();
            }, 3000);
        }
    }

    render() {
        const titleTexts = {
            search: 'Advanced Search is available exclusively for Power Users',
            college_module: 'College tools are available exclusively for Power Users',
            premium_clubs: 'Premium clubs are available exclusively for Power Users',
            player_stats: 'Player metrics are exclusively for Power Users',
            event_discount: 'Discounted registration is available exclusively for Power Users',
            personal_club_limit: '8+ friends in your club is available exclusively for Power Users',
            personal_club_paid_event: 'Paid events are available exclusively for Power users',
        };

        const subtitleTexts = {
            college_module: 'Access college reports, Team6 ratings, and compare college rosters against any other player.',
            premium_clubs: '',
            player_stats: '',
            event_discount: 'Register for unlimited verified events at a discounted price',
            personal_club_limit: '',
            personal_club_paid_event: '',
        };

        const { showCheckout, popupHeight, isAustrlainPowerUpgrade, playerPaymentMethods } = this.state;
        const { onCloseClick, type, auth, isProTennisPowerUpgrade, referral, upgradePopup } = this.props;

        return (
            <div>
                <PopUp
                    className="popup-md"
                    config={{
                        noPadding: false,
                        fullScreen: true,
                        style: {
                            height: popupHeight,
                            maxHeight: '95vh',
                        },
                    }}
                    onCloseClick={onCloseClick}
                >
                    {showCheckout
                        ? (
                            <CheckoutForm
                                ref={this.setCheckoutForm}
                                formType="powered"
                                interval={this.state.selectedInterval}
                                onUpdate={this.setPopupHeight}
                                onComplete={this.handleSuccess}
                                playerPaymentMethods={playerPaymentMethods}
                            />
                        ) : (
                            <>
                                {isProTennisPowerUpgrade || isAustrlainPowerUpgrade ? (
                                    <PowerEventUpgradeContent
                                        isLoading={upgradePopup.isLoading}
                                        data={upgradePopup.data}
                                        user={auth.user}
                                        onClick={this.handleClick}
                                        referral={referral}
                                        yearlySubscriptionOnly={!isAustrlainPowerUpgrade}
                                    />
                                ) : (
                                    <PowerEventUpgrade
                                        titleText={type ? titleTexts[this.props.type] : 'Get exclusive benefits for Power Users'}
                                        subtitleText={type ? subtitleTexts[this.props.type] : ''}
                                        onClick={this.handleClick}
                                    />
                                )}
                            </>
                        )}
                </PopUp>
            </div>
        );
    }
}

const mapStateToProps = ({ auth, upgradePopup }) => {
    return { auth, upgradePopup };
};

const mapDispatchToProps = dispatch => {
    return {
        fetchUpgradePopup: (prismicUid) => dispatch(fetchUpgradePopup(prismicUid)),
        getPaymentMethods: () => dispatch(getPaymentMethods()),
    };
};

export default compose(
    connect(mapStateToProps, mapDispatchToProps)(UpgradeToPowerPopUp),
);
